
import Hero from "../../components/Hero/Hero";
import WhyChooseUs from "../../components/WhyChooseUs/WhyChooseUs";
import ServicesSection from "../../components/ServicesSection/ServicesSection";
import HowItWorks from "../../components/HowItWorks/HowItWorks";
import Testimonials from "../../components/Testimonials/Testimonials";
import FAQ from "../../components/FAQ/FAQ";
import CTA from "../../components/CTA/CTA";




function Home() {
  return (
    <>
      <Hero />
      <WhyChooseUs />
      <ServicesSection />
      <HowItWorks />
      <Testimonials/>
      <FAQ/>
      <CTA/>
    </>
  );
}

export default Home;